import { mapValues, merge, pipe, placeholder } from 'lodash/fp'

export const clearKey = (key) => (state) =>
  pipe([
    // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
    mapValues((value) => (value[key] ? { ...value, [key]: false } : value)),
    merge(placeholder, state[key] ? { [key]: false } : {}),
  ])(state)

export default clearKey
